'use strict';

var _security = require('./_security.module');

var _security2 = _interopRequireDefault(_security);

var _authService = require('./authService');

var _authService2 = _interopRequireDefault(_authService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*jshint esversion: 6 */
_security2.default.provider('authService', AuthServiceProvider);

function AuthServiceProvider() {
    var baseUrl = window.location.protocol + '//' + window.location.host;
    //var authService;
    //https://github.com/IdentityModel/oidc-client-js/wiki#configuration
    var defaultSettings = {
        //authority: "https://dev-sso.febelco.be", // "https://idsv-webhost.febelco.be",
        //client_id: "Profficina.Admin",
        redirect_uri: baseUrl + '/loginRedirect.html',
        post_logout_redirect_uri: baseUrl

        // Required if you want to use the silent_renew
        , response_type: 'id_token token'
        //scope: "openid profile email profficinaAdmin",

        // Silent renew will get a new access_token via an iframe just prior to the old access_token expiring (60 seconds prior)
        // The HTML file will be used in a dynamically created iframe to renew the token. The URL of that page is passed to the token manager
        // settings to instruct it to automatically renew the token when it expires.
        // The token manager will renew the token 60 seconds before it expires, which explains why we chose to change to access token 
        // lifetime to 70 seconds (client.cs of the Identity server). This means the token will be renewed every 10 seconds.
        , silent_redirect_uri: baseUrl + '/silentRenew.html',
        automaticSilentRenew: false

        // This will allow all the OIDC protocol claims to be visible in the window. 
        // Normally a client app wouldn't care about them or want them taking up space
        , filterProtocolClaims: false

        // This will use the user info endpoint if it's an OIDC request and there's an access_token
        , loadUserInfo: false
        // Will raise events for when user has performed a signout at the OP.
        // (default: true)
        , monitorSession: false
        // Sets the interval for cheking if the session is still valid.
        , checkSessionInterval: 10000
        // Storage object used to persist User for currently authenticated user. E.g. userStore: new WebStorageStateStore({ store: window.localStorage })
        // (default: session storage)
        // ,userStore: new WebStorageStateStore({ store: window.sessionStorage })
        // The number of seconds before an access token is to expire to raise the accessTokenExpiring event.
        // (default: 60)
        // ,accessTokenExpiringNotificationTime: 60
    },
        settings = Object.assign({}, defaultSettings);

    this.configure = function (appSettings, url) {
        if (url) {
            baseUrl = url;
        }

        settings = Object.assign(defaultSettings, appSettings);
    };

    this.getSettings = function () {
        return Object.assign({}, settings);
    };

    this.getSignInPath = function () {
        return settings.redirect_uri.replace(baseUrl, '');
    };

    this.getSignOutPath = function () {
        return settings.post_logout_redirect_uri.replace(baseUrl, '');
    };

    this.$get = ['$log', '$q', '$location', '$exceptionHandler', 'Analytics', function ($log, $q, $location, $exceptionHandler, Analytics) {
        return new _authService2.default($log, $q, $location, $exceptionHandler, settings, Analytics);
    }];
}

//SecurityModule.service("authService", AuthService);

//AuthService.$inject = ["$log", "$document"];

//function AuthService($log, $q, settings) {
//    const oidcMgr = new OidcClient.UserManager(settings);
//    var callbacks = [];
//    var loggedInUser;
//    var initialized;
//
//    //OidcClient.Log.logger = $log;
//
//    // Raised when a user session has been established (or re-established)
//    oidcMgr.events.addUserLoaded(function(user) {
//        loggedInUser = user;
//
//        callbacks.forEach(callback => callback(user));
//        $log.debug("oidcMgr.events.addUserLoaded()");
//    });
//    oidcMgr.events.addUserUnloaded(function() {
//        loggedInUser = undefined;
//        $log.debug("oidcMgr.events.addUserUnloaded()");
//    });
//    oidcMgr.events.addAccessTokenExpiring(function() {
//        $log.debug("oidcMgr.events.addAccessTokenExpiring()");
//    });
//    oidcMgr.events.addAccessTokenExpired(function() {
//        loggedInUser = undefined;
//        $log.debug("oidcMgr.events.addAccessTokenExpired()");
//    });
//    oidcMgr.events.addSilentRenewError(function(e) {
//        loggedInUser = undefined;
//        $log.debug(" oidcMgr.events.addSilentRenewError(): ", e.message);
//    });
//    oidcMgr.events.addUserSignedOut(e => {
//        loggedInUser = undefined;
//        $log.debug(" oidcMgr.events.userSignedOut(): ", e);
//    });
//
//    function init() {
//        initialized = false;
//        return oidcMgr.getUser().then(user =>{ 
//            loggedInUser = user;
//            initialized = true; 
//        }, () => initialized = true);
//    }
//
//    function signIn(requestedUrl, acrValues) {
//        debugger;
//        $log.debug("Security - sign in");
//
//        if(this.isAuthenticated() && !acrValues){
//            return $q.resolve();
//        }
//
//        if(initialized === false){
//            var deferred = $q.defer();
//            setTimeout(function(ctx, url) {
//                ctx.signIn(url).then(deferred.resolve, deferred.reject, deferred.notify);
//            }, 100, this, requestedUrl);
//            return deferred.promise;
//        }
//
//        let signInObj = { 
//            scope: settings.scope, 
//            response_type: settings.response_type 
//        };
//
//        if(acrValues){
//            var acr_values = "";
//            for (var key in acrValues) {
//                if (acrValues.hasOwnProperty(key)) {
//                    acr_values += key + ":" + acrValues[key] + " ";                    
//                }
//            }
//            signInObj.acr_values = acr_values.trim();
//        }
//
//        window.sessionStorage.setItem("redirectUrl", requestedUrl);
//
//        return oidcMgr.signinRedirect(signInObj).then(function() {
//            $log.debug("Security - sign in success");
//            return $q.reject();
//        }, function(e) {
//            $log.debug("Security - sign in failed: " + e);
//            return $q.reject();
//        });
//    }
//
//    function processLoginResponseData(responseData) {
//        return oidcMgr.signinRedirectCallback(responseData).then(function(/*user*/) {
//            $log.debug("Security - signed in");
//            //loggedInUser = user;
//            let redirectUrl = window.sessionStorage.getItem("redirectUrl") || "/";
//            // Clean up
//            window.sessionStorage.removeItem("redirectUrl");
//            return redirectUrl;
//        }, function(e) {
//            $log.debug("Security - sign in failed: " + e);
//            loggedInUser = undefined;
//            return "/401";
//        });
//    }
//
//    function signOut() {
//        $log.debug("Security - sign out");
//        return oidcMgr.signoutRedirect().then(() => loggedInUser = undefined);
//    }
//
//    function getAccessToken() {
//        if (loggedInUser) {
//            return loggedInUser.access_token;
//        }
//        return "";
//    }
//
//    function isAuthenticated() {
//        return settings.disableSecurity || !!loggedInUser;
//    }
//
//    function getUser() {
//        if (loggedInUser) {
//            return loggedInUser.profile;
//        }
//        return;
//    }
//
//    function addUserLoadedEvent(callback){
//        callbacks.push(callback);
//        return () => callbacks.splice(callbacks.findIndex(callback),1);
//    }
//
//    return {
//        addUserLoadedEvent: addUserLoadedEvent,
//        getAccessToken: getAccessToken,
//        getUser: getUser,
//        init: init,
//        isAuthenticated: isAuthenticated,
//        processLoginResponseData: processLoginResponseData,
//        signIn: signIn,
//        signOut: signOut
//    };
//}


//////////////////
// WEBPACK FOOTER
// ./blocks/security/authService.provider.js
// module id = 697
// module chunks = 0